import React, { useContext } from "react";
import { ConfigContext, CurrentContext } from "../../App";
import NextButton from "../elements/NextButton";
import TextButtonGroup from "../TextButtonGroup";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";

function Seats() {
	const current = useContext( CurrentContext );
	const config = useContext( ConfigContext );
	const innerVersion = config.inside.versions.find( v => v.name === current.inside_version )!;

	return <div className="flex configuration-part active">
		<div className="flex configuration-part-headline">
			<img className="part-headline-img"
			     src={logo}
			     alt="logo" />
			<h2>Sitze</h2>
		</div>

		

		<TextButtonGroup heading={"Sitzanzahl"}
		                 name={"seats"}
		                 disableFirst={innerVersion.includedSeats}
		                 elements={[ "0", "1", "2", "3", "4", "5" ]}
		/>

		<NextButton />
	</div>;
}

export default Seats;
